var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategory7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24_2985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5876 0.590332H39.283C40.6306 0.590332 41.9392 0.805176 43.2087 1.25439C45.0447 1.91846 46.7048 3.09033 47.9548 4.61377C49.2244 6.13721 50.0642 8.01221 50.3572 9.96533C50.4744 10.688 50.4939 11.4106 50.4939 12.1333V39.145C50.4939 40.0044 50.4548 40.8833 50.279 41.7231C49.8884 43.6567 48.9705 45.4731 47.6423 46.938C46.3337 48.4028 44.615 49.4966 42.7595 50.0825C41.6267 50.4341 40.4548 50.5903 39.2634 50.5903C38.7361 50.5903 11.5095 50.5903 11.0994 50.5708C9.10718 50.4731 7.13452 49.8286 5.47436 48.7153C3.85327 47.6216 2.52514 46.0981 1.66577 44.3403C0.923583 42.8364 0.552489 41.1567 0.552489 39.4771V11.7036C0.513426 10.0435 0.864989 8.40283 1.58765 6.91846C2.42749 5.16065 3.73608 3.61768 5.35718 2.52393C7.01733 1.39111 8.97046 0.727051 10.9626 0.629395C11.158 0.590332 11.3728 0.590332 11.5876 0.590332Z",
    fill: "url(#paint0_linear_24_2985)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6619 41.4888C42.4861 41.2153 42.2908 40.9419 42.0759 40.688C41.5876 40.102 41.0212 39.5942 40.3962 39.1645C39.615 38.6372 38.697 38.3052 37.7595 38.2661C37.0955 38.227 36.4314 38.3442 35.8064 38.5786C35.1814 38.7935 34.5759 39.106 33.99 39.4185C33.3064 39.77 32.6228 40.1216 31.9001 40.4145C31.0408 40.7661 30.1423 41.0396 29.2244 41.2349C28.072 41.4497 26.9001 41.5278 25.7478 41.5083C23.658 41.4692 21.5681 41.1567 19.5759 40.5708C17.8181 40.0435 16.1384 39.3208 14.5564 38.4028C13.1697 37.6021 11.8806 36.6841 10.6697 35.6489C9.67358 34.7895 8.75562 33.8716 7.89624 32.895C7.3103 32.2114 6.7439 31.4888 6.21655 30.7466C6.00171 30.4536 5.8064 30.1411 5.63062 29.8286L0.474365 24.2622V11.6645C0.474365 5.55127 5.41577 0.590332 11.5291 0.590332H21.3923L28.697 8.01221C45.1814 19.2231 39.8494 31.5864 39.8494 31.5864C39.8494 31.5864 44.5369 36.8599 42.6619 41.4888Z",
    fill: "url(#paint1_linear_24_2985)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7361 8.01221C45.2205 19.2231 39.8884 31.5864 39.8884 31.5864C39.8884 31.5864 44.5759 36.8794 42.6814 41.5083C42.6814 41.5083 40.7478 38.2661 37.5056 38.2661C34.3806 38.2661 32.5447 41.5083 26.2556 41.5083C12.2517 41.5083 5.63062 29.8091 5.63062 29.8091C18.2478 38.1099 26.8611 32.231 26.8611 32.231C21.1775 28.9302 9.08765 13.1489 9.08765 13.1489C19.615 22.1138 24.1658 24.4771 24.1658 24.4771C21.4509 22.231 13.8337 11.2544 13.8337 11.2544C19.9275 17.4263 32.0369 26.0396 32.0369 26.0396C35.4744 16.5083 28.7361 8.01221 28.7361 8.01221Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_24_2985",
    x1: 30.2187,
    y1: -1.19385,
    x2: 20.772,
    y2: 52.3806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAAE42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF3E31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_24_2985",
    x1: 25.9845,
    y1: 1.39814,
    x2: 19.0707,
    y2: 40.6085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E39F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D33929"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_2985"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.474365 0.590332)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory7);
export default __webpack_public_path__ + "static/media/category-7.4b520dfcdc5656e1c5e460dd2d348928.svg";
export { ForwardRef as ReactComponent };